module.exports = __webpack_public_path__ + "img/medicocabarete.08cdc74a.png";